import get from 'lodash/get'

export const isActionSuccess = (res) => (res?.type ?? '').endsWith('_SUCCESS')

export const defaultMeta = {}

export const defaultState = {
  isLoading: false,
  isLoaded: false,
  isError: false,
  data: undefined,
  meta: {
    ...defaultMeta,
  },
}
const _defaultState = defaultState

export const dataArrayDefaultState = {
  ...defaultState,
  data: [],
  meta: {
    ...defaultState.meta,
    page: -1,
    isFullyLoaded: false,
  },
}

export const loadingState = (state) => ({
  ...defaultState,
  ...state,
  isLoading: true,
  isLoaded: false,
  isError: false,
})

export const loadedState = (state) => ({
  ...defaultState,
  ...state,
  isLoading: false,
  isLoaded: true,
  isError: false,
})

export const failedState = (state) => ({
  ...defaultState,
  ...state,
  isLoading: false,
  isLoaded: false,
  isError: true,
})

export const generateFetchActionTypes = (actionType) => {
  return {
    request: actionType,
    success: `${actionType}_SUCCESS`,
    failure: `${actionType}_FAIL`,
    clear: `${actionType}_CLEAR`,
  }
}

/**
 * @param actionType
 * @param defaultState
 * @param dataKey
 * @param isListData
 * @param dataDecorator
 * @param metaDataDecorator
 * @param loadMoreParamName
 * @param additionalEffect
 * @returns {function(...[*]=)}
 */
export const generateAsyncReducer =
  ({
    actionType,
    defaultState = _defaultState,
    loadMoreParamName = 'from_timestamp',
    isListData = false,
    dataKey = undefined,
    dataDecorator = undefined,
    metaDataDecorator = undefined,
    additionalStateEffect = undefined,
  }) =>
  (state = defaultState, action) => {
    let keyId =
      get(action, 'meta.id') || get(action, 'meta.previousAction.meta.id')

    switch (action.type) {
      case actionType.request:
        if (keyId) {
          return {
            ...state,
            [keyId]: {
              ...loadingState({
                ...state[keyId],
              }),
            },
          }
        }
        return loadingState({
          ...state,
          meta: action.meta || {},
        })
      case actionType.success:
        let data = dataKey
          ? get(action, `payload.data[${dataKey}]`)
          : action.payload.data
        let meta = {
          ...get(action, 'meta.previousAction.meta', {}),
          ...(action?.payload?.data?.next_page_value
            ? { nextPageValue: action?.payload?.data?.next_page_value }
            : {}),
        }

        if (dataDecorator) {
          data = dataDecorator({
            state,
            data,
            meta,
            rawResponse: action.payload,
          })
        }

        if (metaDataDecorator) {
          meta = {
            ...meta,
            ...metaDataDecorator(state, action.payload.data),
          }
        }

        if (isListData) {
          const page = get(
            action,
            'meta.previousAction.payload.request.params.page',
            0
          )
          const loadMoreParams = get(
            action,
            `meta.previousAction.payload.request.params.${loadMoreParamName}`
          )
          const isFullyLoaded = (data || []).length === 0
          const latestData = keyId ? state[keyId].data || [] : state.data

          data =
            get(action, 'meta.previousAction.meta.clearOnLoad') ||
            (typeof loadMoreParams === 'undefined' && page === 0)
              ? data
              : [...latestData, ...data]
          meta = {
            isFullyLoaded,
            ...(typeof page !== 'undefined' ? { page } : {}),
            ...meta,
          }
        }

        if (keyId) {
          return {
            ...state,
            [keyId]: {
              ...loadedState(state[keyId]),
              data,
              meta,
            },
          }
        }
        return {
          ...loadedState(state),
          data,
          meta,
        }
      case actionType.failure:
        if (keyId) {
          return {
            ...state,
            [keyId]: failedState({
              ...state[keyId],
              error: get(action, 'error.response.data', {}),
            }),
          }
        }
        return failedState({
          ...state,
          error: get(action, 'error.response.data', {}),
        })
      case actionType.clear:
        if (keyId) {
          return {
            ...state,
            [keyId]: defaultState,
          }
        }
        return {
          ...state,
          ...defaultState,
        }
    }

    if (typeof additionalStateEffect === 'function') {
      return additionalStateEffect(state, action) || state
    }

    return state
  }
